module.exports = __webpack_public_path__ + "media/images/sp/visit_reservations_enpou/main_visual-cd0554fcc44284dd771f087ed62788ca.jpg";